import { useCallback } from "react";
import { DefaultNamespace, KeyPrefix, Namespace, useTranslation, UseTranslationOptions } from "react-i18next";

export const useOptionalTranslation = <
  N extends Namespace = DefaultNamespace,
  TKPrefix extends KeyPrefix<N> = undefined
>(
  ns?: N | Readonly<N>,
  options?: UseTranslationOptions<TKPrefix>
) => {
  const { t, i18n, ...translation } = useTranslation(ns, options);

  const optionalT = useCallback(
    (textOrKey) => (i18n.exists(textOrKey) ? t(textOrKey) : textOrKey),
    [i18n, t]
  );

  return {
    t,
    i18n,
    optionalT,
    ...translation
  };
};
